import { render } from "./MyinvBasic.vue?vue&type=template&id=afa5baae&scoped=true&ts=true"
import script from "./MyinvBasic.vue?vue&type=script&lang=ts"
export * from "./MyinvBasic.vue?vue&type=script&lang=ts"

import "./MyinvBasic.vue?vue&type=style&index=0&id=afa5baae&scoped=true&lang=scss"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afa5baae"]])

export default __exports__